import { forwardRef, type Ref, type SVGProps } from "react";
const IconCalendarClockFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25.89 24.45A1 1 0 0 1 25 25a.93.93 0 0 1-.45-.11L22 23.62V21a1 1 0 0 1 2 0v1.38l1.45.73a1 1 0 0 1 .44 1.34M26 11V7a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v4Z"
    />
    <path
      fill="currentColor"
      d="M26 16.67V13H2v10a3 3 0 0 0 3 3h11.69A7 7 0 1 0 26 16.67M23 28a5 5 0 1 1 5-5 5 5 0 0 1-5 5M21 2a1 1 0 0 0-1 1v1h2V3a1 1 0 0 0-1-1M8 3a1 1 0 0 0-2 0v1h2Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCalendarClockFilledSVG);
ForwardRef.displayName = "IconCalendarClockFilled";
export { ForwardRef as IconCalendarClockFilled };
